// GETTERS
export const GET_MEDICINE = 'medicine/GET_MEDICINE';
export const GET_MEDICINE_LIST = 'medicine/GET_MEDICINE_LIST';


// MUTATORS
export const MUTATE_LIST_MEDICINE = 'medicine/MUTATE_LIST_MEDICINE';


// ACTIONS
export const ACTION_LIST_MEDICINES = 'medicine/ACTION_LIST_MEDICINES';
export const ACTION_ADD = 'medicine/ACTION_ADD';
export const ACTION_DELETE = 'medicine/ACTION_DELETE';
export const ACTION_UPDATE = 'medicine/ACTION_UPDATE';
export const ACTION_AGGREGATE = 'medicine/ACTION_AGGREGATE';





// WEBPACK FOOTER //
// ./src/store/constants/medicine.js